import type { Chart } from './types'

// Filter only the displayed buckets. Source totals and share denominators stay intact.
export function visibleTrend(chart: Chart | null | undefined, showPartial = false): Chart | null {
  if (!chart) return null
  return showPartial ? chart : { ...chart, data: chart.data.filter(p => p.period_kind !== 'partial') }
}
export const completeTrendEmpty = 'No complete periods in this range. Enable Show partial periods to see available observations.'
export function trendEmptyMessage(chart: Chart | null | undefined, showPartial: boolean, fallback: string): string {
  return !showPartial && chart?.data.some(p => p.period_kind === 'partial') ? completeTrendEmpty : fallback
}
